import { Directive } from '@angular/core';
import { NEO_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER, NeoTooltipV2 } from '@neogov/pattern-library/neo-tooltip-v2';

/**
 * Shared wrapper around the Pattern Library v2 tooltip (`[neoTooltip]`).
 *
 * Provides a single, design-system-consistent tooltip mechanism for the whole
 * app so features never bind `[neoTooltip]` (or the native `title`) directly.
 * Composed via `hostDirectives` (same pattern as `cmBadge`), so it stays a thin
 * pass-through: the underlying directive does all the work and we only remap the
 * inputs to `cmTooltip*` names.
 *
 * @example
 * ```html
 * <button cmTooltip="Print case"><cm-icon name="print" /></button>
 *
 * <!-- Only show when the text is actually truncated -->
 * <span cmTooltip="{{ fullName }}" [cmTooltipShowOnlyIfEllipsis]="true">{{ fullName }}</span>
 * ```
 */
@Directive({
  selector: '[cmTooltip]',
  standalone: true,
  // Provide the tooltip's scroll strategy locally so consumers work without relying
  // on a global module registration (keeps isolated unit tests self-sufficient).
  providers: [NEO_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER],
  hostDirectives: [
    {
      directive: NeoTooltipV2,
      inputs: [
        'neoTooltip: cmTooltip',
        'neoTooltipPosition: cmTooltipPosition',
        'neoTooltipDisabled: cmTooltipDisabled',
        'neoTooltipShowDelay: cmTooltipShowDelay',
        'neoTooltipHideDelay: cmTooltipHideDelay',
        'neoTooltipShowOnlyIfEllipsis: cmTooltipShowOnlyIfEllipsis',
        'neoTooltipClass: cmTooltipClass',
      ],
    },
  ],
})
export class TooltipDirective {}
